import { render, staticRenderFns } from "./tvbet.vue?vue&type=template&id=0d34dfab&scoped=true"
import script from "./tvbet.vue?vue&type=script&lang=js"
export * from "./tvbet.vue?vue&type=script&lang=js"
import style0 from "./tvbet.vue?vue&type=style&index=0&id=0d34dfab&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d34dfab",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/tvbet.vue
// module id = ITf7
// module chunks = 0